<template>
  <div class="good-item">
    <img :src="data.imageUrl" alt="img.png" />

    <div class="info">
      <span class="title">{{ defaultTips(data.productName) }}</span>
      <span>{{ defaultTips(data.options) }}</span>
      <span class="amount">{{ amountTips(data.stateRefundAmount) }}</span>
      <span>
        <span class="lable">{{ $t('Order.Refund.Success.Mobile.Components.GoodItem.RefundQuantity') }}: </span>
        <span class="value">{{ amountTips(data.productNum) }}</span>
      </span>
      <span>
        <span style="color: red;" class="lable">{{ $t('Order.Refund.Success.Mobile.Components.GoodItem.RefundAmount') }}: </span>
        <span class="value">${{ amountTips((data.stateRefundAmount * data.productNum).toFixed(2)) }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  computed: {
    amountTips() {
      return (value) => value || 0
    },
    defaultTips() {
      return (value) => value || '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.good-item {
  display: flex;
  margin-bottom: 15px;
  justify-content: space-between;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 6px;
    vertical-align: middle;
  }
  .info {
    display: flex;
    color: #10141d;
    font-size: 12px;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 8px;
    .title {
      color: #121212;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .amount,
    .lable {
      font-weight: 500;
    }
    .value {
      color: #e53353;
    }
  }
}
</style>
